import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/ajustes/moneda';
import Monedas from './Moneda';


const ms2p = (state) => {
  return {
    ...state.moneda,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Monedas);